/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize ConstructionAccessAssessment List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './ConstructionAccessAssessmentListView';

export const mapStateToPropsConstructionAccessAssessmentList = mapStateToProps;
export const mapDispatchToPropsConstructionAccessAssessmentList =
  mapDispatchToProps;

export default connect(
  mapStateToPropsConstructionAccessAssessmentList,
  mapDispatchToPropsConstructionAccessAssessmentList
)(View);
